import React, { useState, useRef, FC } from 'react'
import { Button, Input } from 'antd'
import styles from './index.module.less'
import { ButtonProps } from 'antd/lib/button'

interface SearchBarProps {
	placeholder?: string
	debounceTime?: number
	buttonProps?: ButtonProps
	search(value: string): Promise<void> | void
	setLoading?(isLoading: boolean): void
	className?: string
}

const SearchBar: FC<SearchBarProps> = ({ placeholder, search, buttonProps, debounceTime, setLoading, className }) => {
	const [value, setValue] = useState<string>('')
	const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null)

	const handleOnChange = (e: React.ChangeEvent<HTMLInputElement>): void => {
		const newValue = e.target.value
		setValue(newValue)
		clearTimeout(timeoutRef.current)

		const searchWithLoading = async (): Promise<void> => {
			setLoading(true)
			await search(newValue)
			setLoading(false)
		}

		const searchWithoutLoading = async (): Promise<void> => search(newValue)

		timeoutRef.current = setTimeout(setLoading ? searchWithLoading : searchWithoutLoading, debounceTime || 0)
	}

	const handleOnPressEnter = (): void => {
		clearTimeout(timeoutRef.current)
	}

	return (
		<div className={[styles.searchWrapper, className || ''].join(' ')}>
			<Input.Search
				className={styles.search}
				onChange={handleOnChange}
				onPressEnter={handleOnPressEnter}
				placeholder={placeholder && placeholder}
				allowClear
				value={value}
			/>
			{buttonProps && (
				<Button className={`${styles.searchButton} ${buttonProps.className || ''}`} {...buttonProps}>
					{buttonProps.children}
				</Button>
			)}
		</div>
	)
}

export default SearchBar
